var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filingsWarp fOL"},[_vm._v("\n  CopyRight Biotrack Capital .com All Rights Reserved 沪ICP备20013951号-1\n")])}
var staticRenderFns = []

export { render, staticRenderFns }